import PropTypes from 'prop-types';

export const INVITE_PROP_TYPES = {
  // common
  isInvitePreview: PropTypes.bool,
  isMobile: PropTypes.bool,
  customCssUrl: PropTypes.string,
  content: PropTypes.string,
  backgroundColor: PropTypes.string,
  provideButtonText: PropTypes.string,
  provideButtonColor: PropTypes.string,
  provideButtonTextColor: PropTypes.string,
  onDeclineButtonClicked: PropTypes.func,
  onDeferButtonClicked: PropTypes.func,

  // web
  helpTooltipText: PropTypes.string,
  declineButtonText: PropTypes.string,
  declineButtonColor: PropTypes.string,
  declineButtonTextColor: PropTypes.string,
  horizontal: PropTypes.number,
  vertical: PropTypes.number,
  onProvideFeedbackClicked: PropTypes.func,

  // mobile
  headline: PropTypes.string,
  isLandscape: PropTypes.bool,
};

export const DEFAULT_INVITE_DATA = {
  // common
  isInvitePreview: false,
  isMobile: false,
  customCssUrl: null,
  content:
    '<p style="text-align:center;><span style="color:black"><span style="font-size:40px">Let us know what you think</span><br><span style="font-size:18px">It only takes a couple of minutes and will help us improve our service</span></span></p>',
  backgroundColor: '#f5f6f7',
  provideButtonText: 'Provide Feedback',
  provideButtonColor: '#2e77d0',
  provideButtonTextColor: '#ffffff',
  onDeferButtonClicked: null,

  // web
  logoUrl: '',
  helpTooltipText: 'Can i help?',
  declineButtonText: 'Not Right Now',
  declineButtonColor: '#ffffff',
  declineButtonTextColor: '#6b7588',
  onDeclineButtonClicked: null,
  horizontal: 700,
  vertical: 400,

  // mobile
  headline: null,
  isLandscape: false,
};
